var _defs, _style, _path, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxCheckmark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "checkboxCheckmark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 10,
    id: "img1",
    href: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMiAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS43MDcxIDAuMjkyODkzQzEyLjA5NzYgMC42ODM0MTggMTIuMDk3NiAxLjMxNjU4IDExLjcwNzEgMS43MDcxMUw0LjAxNDggOS4zOTk0MUMzLjYyNDI3IDkuNzg5OTQgMi45OTExMSA5Ljc4OTk0IDIuNjAwNTkgOS4zOTk0MUwwLjI5Mjg5MyA3LjA5MTcyQy0wLjA5NzYzMTEgNi43MDEyIC0wLjA5NzYzMTEgNi4wNjgwMyAwLjI5Mjg5MyA1LjY3NzUxQzAuNjgzNDE3IDUuMjg2OTggMS4zMTY1OCA1LjI4Njk4IDEuNzA3MTEgNS42Nzc1MUwzLjMwNzY5IDcuMjc4MDlMMTAuMjkyOSAwLjI5Mjg5M0MxMC42ODM0IC0wLjA5NzYzMTEgMTEuMzE2NiAtMC4wOTc2MzExIDExLjcwNzEgMC4yOTI4OTNaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { fill: #005857;stroke: #ffffff;stroke-linecap:round;stroke-linejoin:round;stroke-width: 1.5 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp0",
    d: "M1.25 12C1.25 6.06 6.06 1.25 12 1.25L12 1.25C17.94 1.25 22.75 6.06 22.75 12L22.75 12C22.75 17.94 17.94 22.75 12 22.75L12 22.75C6.06 22.75 1.25 17.94 1.25 12L1.25 12Z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "checkboxCheckmark",
    href: "#img1",
    transform: "matrix(1,0,0,1,6,7)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxCheckmark);
export default __webpack_public_path__ + "static/media/checkboxCheckmark.119ab262.svg";
export { ForwardRef as ReactComponent };